module.exports = __webpack_public_path__ + "img/5.2.fa17ebb5.jpg";